<template>
    <div class="integration-box">
        <div class="d-flex align-items-center flex-wrap">
            <img :src="require('@/assets/ps.svg')" />
            <button v-if="status" type="button"
                class="h-100 btn btn-primary export equipment ml-0 ml-sm-4 mt-2 mt-sm-0 h-40px w-100px">
                {{ $t('ps.active') }}
            </button>
            <button v-else type="button" class="h-40px btn btn-secondary close-btn ml-4 mt-2 mt-sm-0">
                {{ $t('ps.inactive') }}
            </button>
        </div>
        <p class="mt-3 text-tertiary">
            {{ $t('ps.description') }}
        </p>
        <div v-if="status">
            <div class="d-flex align-items-center flex-wrap mb-3" v-for="(item, index) in buttonsData" :key="index">
                <div>
                    <p class="mb-0">{{ $t(item.titleKey) }}</p>
                    <button @click="setSyncData(item.link)" type="button" :disabled="item.status === true ? false : true"
                        class="h-40px btn btn-primary export equipment mt-2 w-100px text-white">
                        {{ $t('ps.syncData') }}
                    </button>
                </div>
            </div>
        </div>
        <div class="d-flex align-items-center justify-content-between buttons-section flex-wrap">
            <div>
                <b-button type="button" v-if="status" class="w-125px h-40px" variant="danger" @click="removeToken()">
                    {{ $t('ps.deactivate') }}
                </b-button>
                <b-button v-else class="border-0 assigned-equipment w-100px" variant="success"
                    @click="$bvModal.show('modal-ps-activate')">{{ $t('ps.activate') }}</b-button>
            </div>
            <button type="button" class="btn btn-secondary close-btn w-100px h-40px" @click="$emit('close')">
                {{ $t('ps.close') }}
            </button>
        </div>
        <b-modal id="modal-ps-activate" :header-bg-variant="'white'" header-class="border-none" no-close-on-backdrop
            :footer-class="'d-block p-3 m-0'" no-close-on-esc>
            <template #modal-header="{ close }">
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
            </template>
            <div class="text-center">
                <img :src="require('@/assets/ps.svg')" />
            </div>
            <div class="mt-3">
                <b-form-group :label="$t('ps.hostLabel')" class="text-left">
                    <b-form-input type="text" class="input" v-model="form.ps_path"></b-form-input>
                    <p v-if="errors && errors.ps_path" class="field-error">
                        {{ errors.ps_path[0] }}
                    </p>
                </b-form-group>
                <b-form-group :label="$t('ps.accessCodeLabel')" class="text-left">
                    <b-form-input type="text" class="input" v-model="form.ps_token"></b-form-input>
                    <p v-if="errors && errors.access_code" class="field-error">
                        {{ errors.ps_token[0] }}
                    </p>
                </b-form-group>
            </div>
            <template #modal-footer>
                <div class="text-right modal-footer border-0 p-0">
                    <b-button class="mr-3 btn cancel m-0" block @click="closePopup">{{ $t('ps.cancel') }}</b-button>
                    <b-button class="btn save mx-0 m-0" variant="primary" @click="savePsData">{{ $t('ps.save') }}</b-button>
                </div>
            </template>
        </b-modal>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
    name: "PS-Integration",
    props: ["status"],
    data() {
        return {
            form: {
                ps_path: "",
                ps_token: ""
            },
            errors: {},
            showPassword: false,
            buttonsData: [
                {
                    titleKey: "ps.vehicles",
                    link: "sync_ps_vehicles",
                    status: true,
                    data: "Vehicle",
                },
                {
                    titleKey: "ps.drivers",
                    link: "sync_ps_drivers",
                    status: true,
                    data: "Driver",
                },
            ],
        };
    },
    methods: {
        ...mapActions([
            "setLoader",
            "setNotification",
            "setAssetsData",
            "getAssetsData",
            "updateCompany"
        ]),
        closePopup() {
            this.$bvModal.hide('modal-ps-activate')
            this.errors = {}
            this.showPassword = false
            this.form = {
                ps_path: "",
                ps_token: ""
            }
        },
        async setSyncData(link) {
            try {
                this.setLoader(true);
                await this.setAssetsData(link);
                await this.setNotification({
                    msg: this.$t('ps.syncSuccess'),
                    type: "success",
                    color: "green",
                });
                this.setLoader(false);
            } catch (error) {
                this.setLoader(false);
                await this.setNotification({
                    msg: error,
                    type: "error",
                    color: "red",
                });
            }
        },
        async removeToken() {
            try {
                delete this.company[0].logo
                await this.updateCompany({
                    id: this.userCompany,
                    payload: { ...this.company[0], ps_token: "", ps_path: "", state: this.company[0].state.id },
                });
                await this.setNotification({
                    msg: this.$t('ps.removeSuccess'),
                    type: "success",
                    color: "green",
                });
            }
            catch (e) {
                console.log(e)
            }
        },
        async savePsData() {
            try {
                this.errors = {}
                const nullKeys = this.checkNullValues({
                    ps_path: this.form.ps_path,
                    ps_token: this.form.ps_token
                });
                if (nullKeys.length === 0) {
                    delete this.company[0].logo
                    await this.updateCompany({
                        id: this.userCompany,
                        payload: { ...this.company[0], ps_path: this.form.ps_path, ps_token: this.form.ps_token, state: this.company[0].state.id },
                    });
                    await this.setNotification({
                        msg: this.$t('ps.integrationSuccess'),
                        type: "success",
                        color: "green",
                    });
                    this.closePopup()
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('ps.fieldRequired')];
                    });
                    throw error;
                }
            }
            catch (error) {
                if (typeof error === "object") {
                    this.errors = error;
                    // eslint-disable-next-line no-ex-assign
                }
            }
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (!value) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
    },
    computed: {
        ...mapGetters(["assetsData", "company", "userCompany"]),
    },
    mounted() { },
};
</script>
<style>
.integration-box, .password-change-box {
    min-height: 430px;
    position: relative;
}

.integration-box .buttons-section, .password-change-box .buttons-section {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
}

@media (max-width: 575px) {
    .integration-box {
        min-height: 500px;
    }
}
</style>
  